export default {
  kindOnboarding: 'Onboarding',
  kindOffboarding: 'Offboarding',
  allSites: 'All sites',
  unknownSite: 'Unknown',
  title: 'Checklists',
  description: 'Reusable task lists for onboarding and offboarding. Trigger them from an employee\'s profile; each applies to the sites you choose.',
  newChecklist: 'New checklist',
  templates: 'Checklist templates',
  emptyTitle: 'No checklists yet',
  emptyMessage: 'Create one, such as a site induction, then trigger it for new starters.',
  inactive: 'Inactive',
  active: 'Active',
  taskCountOne: '{count} task',
  taskCountOther: '{count} tasks',
  editNamed: 'Edit {name}',
  updated: 'Checklist updated.',
  created: 'Checklist created.',
  editChecklist: 'Edit checklist',
  type: 'Type',
  appliesTo: 'Applies to',
  appliesToHint: 'Leave all unticked to apply to every site.',
  tasks: 'Tasks',
  tasksHint: 'Due days are counted from the start date (onboarding) or last day (offboarding).',
  taskN: 'Task {n}',
  taskPlaceholder: 'Task',
  taskNDueDays: 'Task {n} due days',
  removeTaskN: 'Remove task {n}',
  addTask: 'Add task',
}
